$(document).ready(function() {
  $(".job-show-more").on("click", function() {
    var job = $(this).parent();
    var id = $(this).data("id");
    $(job)
      .find(".job-overlay")
      .toggleClass("hidden");
    $(job)
      .find(".job-description")
      .toggleClass("full");
    if ($(this).html() == "Show More") $(this).html("Show Less");
    else $(this).html("Show More");
    $(window).scrollTop($(id).offset().top - 75);
  });
});
